<form>
    <ul class="nav nav-tabs" id="tradeboardTabs" role="tablist">
        <li class="nav-item" role="presentation" *ngFor="let tb of tradeboards">
            <div class="hstack">
              <button class="nav-link" [ngClass]="tb.active" id="{{tb.id}}" data-bs-toggle="tab" attr.data-bs-target="#{{tb.content_id}}" type="button"
                role="tab" attr.aria-controls="{{tb.name}}" aria-selected="true">{{ tb.name }}
                <button type="button" class="btn-close" aria-label="Close"></button>
              </button>  
            </div>
        </li>
    </ul>
    <div class="tab-content" id="tradeboardTabContent">
      <div class="tab-pane fade show" [ngClass]="tb.active"  id="{{tb.content_id}}" role="tabpanel" attr.aria-labelledby="{{tb.target}}" *ngFor="let tb of tradeboards">
        <app-tradeboard-content [data]="tb.content"></app-tradeboard-content>
      </div>
    </div>
</form>
